module.exports = __webpack_public_path__ + "static/abiertos-0b88c22d242e8c6baeba9fa10d1b7942.svg";